import { defineStore } from "pinia";
import { ref, nextTick } from "vue";
import tools from "@/utils/tools.js";
import globalConfig from "@/config/config.js";
import apiTts from "@/api/api/apiTts.js";
import message from "@/components/functionCallComponent/message.jsx";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import { $$t } from "@/i18n/i18n.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import { openCreditDialog } from "@/page/credits/addCreditsDialog.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import { showActionDialog } from "@/components/functionCallComponent/action/action.js";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import ShowInviteDialog from "@/components/inviteDialog/inviteDialog.js";
import {
  getInvitePop,
} from "@/api/api/apiCredit.js";
// https://rg975ojk5z.feishu.cn/wiki/WvhHw2ZTgicqKekQEtecYKaTnNo

const TtsVocalMusicStoreApiMap = {
  0: apiTts.queryTtsVoiceLibraryData,
  1: apiTts.getTtsVoiceLibrary,
  2: apiTts.getTtsVoiceLibrary,
  3: apiTts.getTtsVoiceLibrary,
  4: apiTts.getTtsVoiceLibrary,
  "1_1": apiTts.getTtsVoiceLibrary,
  "1_2": apiTts.getTtsVoiceLibrary,
};
const userTtsVocalMusicStore = defineStore({
  id: "ttsVocalMusicStore",
  state: () => {
    return {
      TabDataSuffixMap: {
        1: "all",
        2: "used",
        3: "upload",
        4: "liked",
        "1_1": "all_all",
        "1_2": "all_quality",
        0: 'search',
      },
      TabQueryParamsMap: {
        0: {},
        1: { type: 1 },
        2: { type: 2 },
        3: { type: 3 },
        4: { type: 4 },
        "1_1": { type: 1, tab: 1 },
        "1_2": { type: 1, tab: 2 },
      },


      datas_all: [],
      datas_used: [],
      datas_upload: [],
      datas_liked: [],
      datas_all_all: [],
      datas_all_quality: [],
      datas_search: [],

      loadmoreid_all: "",
      loadmoreid_use: "",
      loadmoreid_upload: "",
      loadmoreid_liked: "",
      loadmoreid_all_all: "",
      loadmoreid_all_quality: "",
      loadmoreid_search: "",

      isloading_all: false,
      isloading_use: false,
      isloading_upload: false,
      isloading_liked: false,
      isloading_all_all: false,
      isloading_all_quality: false,
      isloading_search: false,

      hasInit_all: false,
      hasInit_use: false,
      hasInit_upload: false,
      hasInit_liked: false,
      hasInit_all_all: false,
      hasInit_all_quality: false,
      hasInit_search: false,


      curUseReferMusic: null,
      loadtimestamp_all: "",
      loadtimestamp_use: "",
      loadtimestamp_upload: "",
      loadtimestamp_liked: "",
      loadtimestamp_all_all: "",
      loadtimestamp_all_quality: "",
      loadtimestamp_search: "",

      curUseMusicTabCode: null,
    };
  },
  actions: {
    initReferMusic(data) {
      // this.updateCurUseReferMusic();
    },
    clearAllReferSelectData() {
      this.datas_liked = [];
      this.datas_upload = [];
      this.datas_used = [];
      this.datas_all = [];

      this.loadmoreid_liked = "";
      this.loadmoreid_upload = "";
      this.loadmoreid_use = "";
      this.loadmoreid_all = "";

      this.isloading_liked = false;
      this.isloading_upload = false;
      this.isloading_use = false;
      this.isloading_all = false;

      this.hasInit_liked = false;
      this.hasInit_upload = false;
      this.hasInit_use = false;
      this.hasInit_all = false;
    },

    togglePlayMusic(item, tabCode) {
      const globalPlayDataStore = useGlobalPlayDataStore();
      globalPlayDataStore.setCurPlayData(null)
      // globalPlayDataStore.setCurPlayGroup(`tts_voice_datas_${this.TabDataSuffixMap[tabCode]}`);
      // let datas = this[`datas_${this.TabDataSuffixMap[tabCode]}`].map(
      //   (item) => {
      //     return {
      //       ...item,
      //       mp3_url: item.mp3_url + `?tts_voice_tab_code=${tabCode}&id=${item.id}`,
      //       song_id: item.id,
      //     }
      //   }
      // );
      // globalPlayDataStore.setPlayDatas(datas ?? [], {
      //   ...item,
      //   mp3_url: item.mp3_url + `?tts_voice_tab_code=${tabCode}&id=${item.id}`,
      //   song_id: item.id,
      // });
    },


    addVoiceDataToPlayList(tabCode) {
      // const globalPlayDataStore = useGlobalPlayDataStore();
      // if (globalPlayDataStore.curPlayGroup != `tts_voice_datas_${this.TabDataSuffixMap[tabCode]}`) {
      //   return;
      // }
      // let adddatas = this[`datas_${this.TabDataSuffixMap[tabCode]}`]?.map(
      //   (item) => {
      //     return {
      //       ...item,
      //       mp3_url: item.mp3_url + `?type=refer_list_tab=${tabCode}&id=${item.id}`,
      //       song_id: item.id,
      //     }
      //   }
      // );
      // globalPlayDataStore.addPlayDatas(adddatas ?? [], 'id');
    },
    updateCurUseReferMusic(data, tabCode) {
      this.curUseReferMusic = data;
      this.curUseMusicTabCode = tabCode;
    },
    getReferMusic() {
      return this.curUseReferMusic;
    },

    initLibraryData(params, done, errordone, isSearch, showLoading) {
      this.datas_all = [];
      this.loadmoreid_all = "";
    },

    init(params, done, errordone, isSearch, showLoading) {
      const { query_type } = params;
      console.log("initreferdata", params);
      let closeMsg = null;
      return new Promise((resolve, reject) => {
        if (showLoading) {
          closeMsg = message.loading({
            position: "center",
            content: $$t("create.loading"),
          });
        }

        this[`isloading_${this.TabDataSuffixMap[query_type]}`] = true;
        params = { ...params, ...this.TabQueryParamsMap[query_type] };
        this.getdatas(params, done, errordone, isSearch ?? true)
          .then((datas) => {
            this[`hasInit_${this.TabDataSuffixMap[query_type]}`] = true;
            this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
            this[`hasInit${this.TabDataSuffixMap[query_type]}`] = false;
            resolve(datas);
            closeMsg && closeMsg.clear();
          })
          .catch((err) => {
            closeMsg && closeMsg.clear();
            this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
            reject(err);
          });
      });
    },
    getdatas(params, done, errordone, isSearch) {
      const { query_type } = params;
      let loadtimestamp = new Date().getTime();
      this[`loadtimestamp_${this.TabDataSuffixMap[query_type]}`] = loadtimestamp;
      const getReferMusics = TtsVocalMusicStoreApiMap[query_type];

      return new Promise(async (resolve, reject) => {
        getReferMusics(params)
          .then((res) => {
            const { data, code, msg } = res;
            if (code == 200) {
              if (
                !isSearch ||
                this[`loadtimestamp_${this.TabDataSuffixMap[query_type]}`] ==
                loadtimestamp
              ) {
                this[`datas_${this.TabDataSuffixMap[query_type]}`] = data.list ?? [];
                this[`loadmoreid_${this.TabDataSuffixMap[query_type]}`] =
                  data.last_id;
              }
              done && done(data.list ?? [], !data.more);
              resolve(this[`datas_${this.TabDataSuffixMap[query_type]}`]);
            } else {
              errordone && errordone(code == -200);
              // if (code == -200) {
              //   message.error({ content: msg });
              // } else {
              //   message.error({ content: "加载失败" });
              // }
              reject(this[`datas_${this.TabDataSuffixMap[query_type]}`]);
            }
          })
          .catch((err) => {
            errordone && errordone();
            reject(err);
            // message.error(err.msg)
          });
      });
    },
    async refresh(params, done, errordone) {
      const { query_type } = params;
      if (this[`isloading_${this.TabDataSuffixMap[query_type]}`]) {
        done && done();
        return;
      }
      this[`isloading_${this.TabDataSuffixMap[query_type]}`] = true;
      params = { ...params, ...this.TabQueryParamsMap[query_type] };
      this.getdatas(params, done, errordone)
        .then((res) => {
          this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
        })
        .catch((e) => {
          this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
        });
    },
    async loadMore(params, done, errordone) {
      const { query_type } = params;
      params.last_id = this[`loadmoreid_${this.TabDataSuffixMap[query_type]}`];
      if (this[`isloading_${this.TabDataSuffixMap[query_type]}`]) {
        done && done();
        return;
      }
      if (!params.last_id) {
        done && done([], true);
        return;
      }
      this[`isloading_${this.TabDataSuffixMap[query_type]}`] = true;
      const getReferMusics = TtsVocalMusicStoreApiMap[query_type];
      params = { ...params, ...this.TabQueryParamsMap[query_type] };

      getReferMusics(params)
        .then((res) => {
          const { data, code, msg } = res;
          let addList = (data.list ?? []).filter((item) => {
            return !this[`datas_${this.TabDataSuffixMap[query_type]}`].find(
              (i) => i.id == item.id
            )
          })
          if (code == 200) {
            this[`datas_${this.TabDataSuffixMap[query_type]}`] = this[
              `datas_${this.TabDataSuffixMap[query_type]}`
            ].concat(addList);
            this[`loadmoreid_${this.TabDataSuffixMap[query_type]}`] = data.last_id;
            this.addVoiceDataToPlayList(query_type);
          }

          //  else {
          //   message.error({ content: msg });
          // }

          nextTick(() => {
            if (code == 200) {
              done && done(addList, !data.more);
            } else {
              errordone && errordone(code == -200);
            }
            this[`isloading_${this.TabDataSuffixMap[query_type]}`] = false;
          });
        })
        .catch((err) => {
          errordone && errordone(err);
        });
    },
    insertUploadData(refer) {
      this[`datas_${this.TabDataSuffixMap[3]}`] = [
        refer,
        ...this[`datas_${this.TabDataSuffixMap[3]}`],
      ];
    },
    deleteCurUseMusicByAudit(refer) {
      if (refer != null && refer.id == this.curUseReferMusic?.id) {
        this.deleteReferItemFromList(refer, true);
        this.updateCurUseReferMusic(null, null);
      }
    },
    setCurUseMusic(refer, tabCode) {
      // let lastUseMusic = this.curUseReferMusic;
      this.updateCurUseReferMusic(refer ?? null, tabCode);
      // if (isSave) {
      //   return;
      // }
      // if (refer == null && lastUseMusic != null && lastUseMusic.id) {
      //   // const closeMsg=  message.loading({content: '取消中'})
      //   apiTts
      //     .deleteReferenceMusic({
      //       control_type: 3,
      //       refer_id: lastUseMusic.id,
      //     })
      //     .then((res) => {
      //       if (res.code == 200) {
      //       } else {
      //         return;
      //       }
      //     })
      //     .catch((err) => {
      //       //  closeMsg.clear();
      //     });
      // } else {
      // }
    },
    updateReferMusicInfo(id, data, tabCode) {
      for (let i = 0; i < this.datas_all.length; i++) {
        if (this.datas_all[i].id == id) {
          Object.assign(this.datas_all[i], data);
          break;
        }
      }
      for (let i = 0; i < this.datas_used.length; i++) {
        if (this.datas_used[i].id == id) {
          Object.assign(this.datas_used[i], data);
          break;
        }
      }
      for (let i = 0; i < this.datas_upload.length; i++) {
        if (this.datas_upload[i].id == id) {
          Object.assign(this.datas_upload[i], data);
          break;
        }
      }
      for (let i = 0; i < this.datas_all_all.length; i++) {
        if (this.datas_all_all[i].id == id) {
          Object.assign(this.datas_all_all[i], data);
          break;
        }
      }
      for (let i = 0; i < this.datas_all_quality.length; i++) {
        if (this.datas_all_quality[i].id == id) {
          Object.assign(this.datas_all_quality[i], data);
          break;
        }
      }
      for (let i = 0; i < this.datas_search.length; i++) {
        if (this.datas_search[i].id == id) {
          Object.assign(this.datas_search[i], data);
          break;
        }
      }
      if (this.curUseReferMusic?.id == id) {
        Object.assign(this.curUseReferMusic, data);
      }
      if (tabCode) {
        this[`datas_${this.TabDataSuffixMap[tabCode]}`] = [].concat(this[`datas_${this.TabDataSuffixMap[tabCode]}`])  
      }
    },
    removeReferItemFromList(refer, listkey) {
      let index = this[`datas_${listkey}`].findIndex((item) => item.id == refer.id);
      if (index >= 0) {
        this[`datas_${listkey}`].splice(index, 1);
        this[`datas_${listkey}`] = [].concat(this[`datas_${listkey}`]);
      }
    },
    insertReferItemFromList(refer, listkey) {
      if (refer && !this[`datas_${listkey}`].some(
        (item) => item.id == refer.id
      )) {

        this[`datas_${listkey}`] = [refer, ...this[`datas_${listkey}`]];
      }
    },
    setReferMusic(data) {
      this.curUseReferMusic = data;
    },
    deleteReferItemFromList(refer, isDeleteUse) {
      let index_used = this.datas_used.findIndex((item) => item.id == refer.id);
      let index_all = this.datas_all.findIndex((item) => item.id == refer.id);
      let index_upload = this.datas_upload.findIndex((item) => item.id == refer.id);
      let index_all_all = this.datas_all_all.findIndex((item) => item.id == refer.id);
      let index_all_quality = this.datas_all_quality.findIndex((item) => item.id == refer.id);
      let index_search = this.datas_search.findIndex((item) => item.id == refer.id);
      let index_liked = this.datas_liked.findIndex((item) => item.id == refer.id);


      if (index_used >= 0 && isDeleteUse) {
        this.datas_used.splice(index_used, 1);
        this.datas_used = [].concat(this.datas_used);
      }
      if (index_all >= 0) {
        this.datas_all.splice(index_all, 1);
        this.datas_all = [].concat(this.datas_all);
      }
      if (index_upload >= 0) {
        this.datas_upload.splice(index_upload, 1);
        this.datas_upload = [].concat(this.datas_upload);
      }
      if (index_all_all >= 0) {
        this.datas_all_all.splice(index_all_all, 1);
        this.datas_all_all = [].concat(this.datas_all_all);
      }
      if (index_all_quality >= 0) {
        this.datas_all_quality.splice(index_all_quality, 1);
        this.datas_all_quality = [].concat(this.datas_all_quality);
      }
      if (index_search >= 0) {
        this.datas_search.splice(index_search, 1);
        this.datas_search = [].concat(this.datas_search);
      }
      if (index_liked >= 0) {
        this.datas_liked.splice(index_liked, 1);
        this.datas_liked = [].concat(this.datas_liked);
      }
    },
    deleteReferItem(refer, query_type) {
      let closeMsg = message.loading({
        position: "center",
        content: $$t("create.deleting"),
      });
      apiTts
        .deleteTtsVoiceItem({ id: refer.id })
        .then((res) => {
          closeMsg.clear();
          if (res.code == 200) {
            if (this.curUseReferMusic?.id == refer.id) {
              this.updateCurUseReferMusic(null, null);
            }
            this.deleteReferItemFromList(refer, true);
            message.success({
              position: "top",
              content: $$t("create.delete_success"),
            });
          } else {
            message.error({
              position: "top",
              content: $$t("create.delete_failed"),
            });
          }
        })
        .catch((err) => {
          message.error({
            position: "top",
            content: $$t("create.delete_failed"),
          });
          closeMsg.clear();
        });
    },
    doEditSongTitle(refer, query_type) { },


    goCredits(code, { membership_source1, membership_source2 }) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      const userDataStore = useUserDataStore();
      const is_vip = userDataStore?.userInfo?.user?.is_vip;
      const Router = window?.$getVueCurrentInstance?.().appContext?.config?.globalProperties?.$router
      switch (code) {
        case 6335:
          message.error({
            position: "top",
            content: $$t("editor.subscripe_level_not_met"),
          });
          Router.push({
            name: "subscribe",
            query: {
              membership_source1: membership_source1,
              membership_source2: membership_source2,
            },
          });
          break;
        case 6303:
          const { show_until, discount_type, discount_percent } = userDataStore?.userInfo?.discount ?? {}
          const isShowConer = show_until == 1 && discount_type > 0 && discount_percent > 0;
          showActionDialog({
            content: $$t("create.not_enough_credits_action"),
            cancelLabel: $$t("common.cancel"),
            confirmLabel: is_vip ? $$t("create.buy_credits") : $$t("create.subscribe"),
            confirmConer: isShowConer ? `${discount_percent}% ${$$t("credit.off")}` : null,
            type: "subscribe",
            confirm: (closeAction) => {
              closeAction();
              if (is_vip) {
                openCreditDialog()
                return;
              } else {
                Router.push({
                  name: "subscribe",
                  query: {
                    ...(is_vip
                      ? {
                        show_credits: 1,
                      }
                      : {}),
                    membership_source1: membership_source1,
                    membership_source2: membership_source2,
                  },
                });
              }
              firebaseUtils.logClickEvent("credits_useup", {
                is_vip: is_vip ? 1 : 0,
              });

            },
            cancel: (closeAction) => {
              if (userDataStore?.isLogin) {
                getInvitePop({}).then((res) => {
                  if (res.code == 200) {
                    if (res?.data?.pop) {
                      ShowInviteDialog();
                    }
                  }
                });
              }
              closeAction();
            },
          });

          break;
        case 6310:
          if (is_vip) {
            openCreditDialog();
          } else {
            this.goCredits(6303, {
              membership_source1,
              membership_source2,
            })
          }
          break;
        default:
          break;
      }
    },
  },
});
export default userTtsVocalMusicStore;
// export const VocalMusicStore = userTtsVocalMusicStore()
